// eslint-disable-next-line import/no-cycle
import { APIS, clients } from '@/core/clients';

const client = clients[APIS.SELF_SERVICE.name];
const reportingApi = {
  getPublisherIdsWithStats(payload) {
    return client.get(`/stats/publishers?creativeIds=${payload.creativeIds}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getPublisherStats(payload) {
    return client.post(`/stats/a/${payload.advertiserId}/stats/publisher`, payload.body)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getDailyStats(payload) {
    return client.post(`/stats/stats/daily?campaignIds=${payload.campaignIds}`, payload.body)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getContentDailyStats(payload) {
    return client.post(`/stats/a/${payload.advertiserId}/stats/advertiser-content`, payload.body)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getOverallCreativeCampaignStats(payload) {
    return client.post(`/stats/a/${payload.advertiserId}/creatives/stats`, payload.body)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getGeoLocationIdsWithStats(payload) {
    return client.get(`/stats/geo-locations?campaignIds=${payload.campaignIds}`, payload.body)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getGeoStats(payload) {
    return client.post(`/stats/geo?campaignIds=${payload.campaignIds}`, payload.body)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  downloadContentReportCSV(payload) {
    return client.post(`/stats/a/${payload.advertiserId}/stats/advertiser-content-csv`, payload.body)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  downloadReportAsCSV(payload) {
    return client.post('/stats/generate/csv-report', payload)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  downloadGeoReportCSV(payload) {
    return client.post(`/stats/geo-csv?campaignIds=${payload.campaignIds}`, payload.body)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  // STATEMENTS
  getReportStatementsForType(payload) {
    return client.get(`/stats/campaigns/${payload.campaignId}/statements?type=${payload.type}`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  putReportStatementsForType(payload) {
    return client.put(`/stats/campaigns/${payload.campaignId}/statements`, payload.body)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  getCampaignReportConfiguration(payload) {
    return client.get(`/stats/campaigns/${payload.campaignId}/report-configuration`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  patchCampaignReportConfiguration(payload) {
    return client.patch(`/stats/campaigns/${payload.campaignId}/report-configuration`, payload.body)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  publishCampaignReportStatements(payload) {
    return client.post(`/stats/campaigns/${payload.campaignId}/statements/publish`)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
  patchSummaryEnabledStatements(payload) {
    return client.patch(`/stats/campaigns/${payload.campaignId}/statements`, payload.body)
      .then((response) => response.data)
      .catch((error) => {
        throw error;
      });
  },
};
export default reportingApi;
